<!-- <div class="flex flex-col sm:flex-row items-center md:items-start sm:justify-center md:justify-start flex-auto w-screen px-8 md:px-0">
    <div class="md:flex md:items-center md:justify-center w-full sm:w-auto md:h-screen md:w-full py-8 sm:px-0 md:px-4 sm:p-12 md:p-16 sm:rounded-2xl md:rounded-none sm:shadow md:shadow-none sm:bg-card">
    
    </div>
</div> -->


<section class="flex justify-center items-center w-full">
    <div class="text-center flex flex-col lg:w-2/4 w-full mx-6 md:mx-12 lg:mx-0">
        <!-- Logo -->
        <div class="flex justify-center my-12">
            <img class="w-60" [src]="logo" alt="logo" loading="lazy">
        </div>

        <!-- Title -->
        <div class="mt-8 md:text-4xl text-3xl font-bold tracking-wide">Forgot your password?</div>
        <div class="mt-8 text-lg text-black ">
            Please enter your registered email address below and we’ll send you a link to reset your password. 
        </div>

        <!-- Alert -->
        <fuse-alert
            class="mt-8"
            *ngIf="showAlert"
            [appearance]="'outline'"
            [showIcon]="false"
            [type]="alert.type"
            [@shake]="alert.type === 'error'">
            {{alert.message}}
        </fuse-alert>

        <!-- Forgot password form -->
        <form
            class="mt-8"
            [formGroup]="forgotPasswordForm"
            #forgotPasswordNgForm="ngForm">

            <!-- Email field -->
            <mat-form-field class="w-full">
                <mat-label>Email</mat-label>
                <input
                    id="email"
                    matInput
                    [formControlName]="'email'">
                <mat-error *ngIf="forgotPasswordForm.get('email').hasError('required')">
                    Email address is required
                </mat-error>
                <mat-error *ngIf="forgotPasswordForm.get('email').hasError('email')">
                    Please enter a valid email address
                </mat-error>
            </mat-form-field>

            <!-- Submit button -->
            <button
                class="fuse-mat-button-large w-full mt-3"
                mat-flat-button
                [color]="'accent'"
                [disabled]="!forgotPasswordForm.valid"
                (click)="sendResetLink()">
                <span *ngIf="!forgotPasswordForm.disabled">
                    Reset your password
                </span>
                <mat-progress-spinner
                    *ngIf="forgotPasswordForm.disabled"
                    [diameter]="24"
                    [mode]="'indeterminate'"></mat-progress-spinner>
            </button>

            <!-- Form footer -->
            <div class="flex justify-center items-center mt-8 text-md font-medium text-secondary cursor-pointer" [routerLink]="['/sign-in']">
                <mat-icon svgIcon="heroicons_solid:arrow-left-circle" [color]="'primary'"></mat-icon> <p class="font-bold text-black">Go back</p> 
            </div>

        </form>
    </div>
</section>
